import { render, staticRenderFns } from "./ColumnsSelector.vue?vue&type=template&id=51599ed4&scoped=true&"
import script from "./ColumnsSelector.vue?vue&type=script&lang=ts&"
export * from "./ColumnsSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnsSelector.vue?vue&type=style&index=0&id=51599ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51599ed4",
  null
  
)

export default component.exports